export const SUCCESS_GET_VEHICLES = 'SUCCESS_GET_VEHICLES';
export const FAILED_GET_VEHICLES = 'FAILED_GET_VEHICLES';


// WEBPACK FOOTER //
// src/state/constants/vehicleConstants.js